import { handleApiError, phpApi } from "../../api";

export const updateUserInfo = () => {
  return phpApi.get("/api/user/info").catch(handleApiError);
};

export const pushToken = (token) => {
  return phpApi.post("/api/push", { token }).catch(handleApiError);
};

export const logout = () => {
  return phpApi.post("/api/user/logout").catch(handleApiError);
};
